import { z } from 'zod';

export const lineupPlayerSchema = z
	.object({
		id: z.union([z.number(), z.string()]).optional(),
		name: z.string().optional(),
		playerName: z.string().optional(),
		/** Opta position id (numeric) in datastore payloads. */
		position: z.union([z.number(), z.string()]).optional(),
		/** Human-readable role, e.g. "Goalkeeper". Prefer this for UI. */
		formationPosition: z.string().optional(),
		shirtNumber: z.union([z.number(), z.string()]).optional(),
		isCaptain: z.boolean().optional(),
		hasYellowCard: z.boolean().optional(),
		hasSecondYellowCard: z.boolean().optional(),
		hasStraightRedCard: z.boolean().optional(),
		isPlaying: z.boolean().optional(),
		didStart: z.boolean().optional(),
		timeCameOn: z.number().optional(),
		timeCameOff: z.number().optional(),
		substituted: z.boolean().optional(),
		sortOrder: z.number().optional(),
		avatar: z
			.object({
				url: z.string().optional(),
				altText: z.string().nullable().optional(),
			})
			.passthrough()
			.nullable()
			.optional(),
	})
	.passthrough();

export const teamLineupSchema = z
	.object({
		players: z.array(lineupPlayerSchema).optional(),
		substitutes: z.array(lineupPlayerSchema).optional(),
	})
	.passthrough();

export const lineupSponsorLogoSchema = z
	.object({
		url: z.string().optional(),
		src: z.string().optional(),
		alt: z.string().optional(),
		altText: z.string().optional(),
		width: z.number().optional(),
		height: z.number().optional(),
	})
	.passthrough();

export const lineupSponsorSchema = z
	.object({
		sponsorMessage: z.string().optional(),
		logo: lineupSponsorLogoSchema.optional(),
	})
	.passthrough();

export const matchLineupSchema = z
	.object({
		homeTeam: teamLineupSchema.optional(),
		awayTeam: teamLineupSchema.optional(),
		sponsor: lineupSponsorSchema.optional(),
	})
	.passthrough();

export type LineupPlayer = z.infer<typeof lineupPlayerSchema>;
export type TeamLineup = z.infer<typeof teamLineupSchema>;
export type LineupSponsorLogo = z.infer<typeof lineupSponsorLogoSchema>;
export type LineupSponsor = z.infer<typeof lineupSponsorSchema>;
export type MatchLineup = z.infer<typeof matchLineupSchema>;
